import React from "react";
import Layout from "components/layout";
import { withI18next } from "lib/withI18next";
import DBResourceListComp from "components/resource/DBResourceListComp";
import DBResourceListComp2 from "components/resource/DBResourceListComp2";
import JournalResourceListComp from "components/resource/JournalResourceListComp";
import ResourceListTab from "components/resource/ResourceListTab";
import SearchBlock from "components/search/SearchBlock";
import SearchBlock2 from "components/search/SearchBlock2";
import { autobind } from "react-decoration";
import { page } from "components/page";
import navigate from "lib/navigate";
import qs from "query-string";

@withI18next(["common"])
@page
class ResourceList extends React.Component {
  constructor(props) {
    super(props);
    let state = this.getQueryState(props);
    this.state = state;
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props !== props) {
      if (this.state.auth !== props.readerStore.auth) {
        let { location } = this.props;
        if (location.pathname === "/resourceList") {
          this.resetPage();
        }
      }
      this.setQueryState(props);
    }
  }

  @autobind
  setQueryState(props) {
    let state = this.getQueryState(props);

    if (JSON.stringify(state) !== JSON.stringify(this.state)) {
      this.setState({
        ...state,
      });
    }
  }

  @autobind
  getQueryState(props) {
    let { search, readerStore, appStore } = props;
    let { resourceConfig, globalConfig } = appStore;
    let params = { ...search };
    let {
      resourceType,
      pageNo,
      limit,
      searchInput,
      searchField,
      op,
      showType,
      filterField,
      filterValue,
      sort,
      order,
      pageType,
      subject,
      college,
      unit,
      classSn,
      par,
      phonetic,
      strokes,
      language,
      alphabet,
      dbID,
      searchTarget,
      sc,
      domain,
      searchBlockType,
    } = params;
    let publicationType = "";
    let defaultResourceType =
      resourceConfig && resourceConfig.resourceTabList
        ? resourceConfig.resourceTabList[0]
        : "databases";

    let resourceTypeSet = [
      "databases",
      "network",
      "journal",
      "ejournal",
      "ebook",
      "paper_journal",
    ];

    if (resourceTypeSet.indexOf(resourceType) === -1) {
      resourceType = defaultResourceType;
    }

    if (sort === undefined || sort === "") {
      if (resourceType === "databases") {
        if (pageType === "search") {
          sort = "related";
          order = "desc";
          let dbSearchSortString =
            globalConfig["jumperrwd.resource.dbSearchSort"];
          if (dbSearchSortString !== "") {
            let dbSearchSort = JSON.parse(dbSearchSortString);
            sort = dbSearchSort.sort;
            order = dbSearchSort.order;
          }
        } else if (pageType === "hot") {
          sort = "hot";
          order = "desc";
        } else {
          sort = "ebname";
          order = "asc";
          let dbListSortString = globalConfig["jumperrwd.resource.dbListSort"] || "";
          if (dbListSortString !== "") {
            let dbListSort = JSON.parse(dbListSortString);
            sort = dbListSort.sort;
            order = dbListSort.order;
          }
        }
      } else {
        if (pageType === "hot") {
          sort = "hot";
          order = "desc";
        } else if (pageType === "search") {
          let journalSearchSortString =
            globalConfig["jumperrwd.resource.journalSearchSort"];
          if (journalSearchSortString !== "") {
            let journalSearchSort = JSON.parse(journalSearchSortString);
            sort = journalSearchSort.sort;
            order = journalSearchSort.order;
          }
        } else {
          let journalListSortString =
            globalConfig["jumperrwd.resource.journalListSort"];
          if (journalListSortString !== "") {
            let journalListSort = JSON.parse(journalListSortString);
            sort = journalListSort.sort;
            order = journalListSort.order;
          }
        }
      }
    }

    if (pageType === undefined || pageType === "") {
      pageType = "list";
    }

    pageNo = pageNo || 1;
    limit = limit || 30;
    searchInput = [].concat(searchInput || []);
    searchField = [].concat(searchField || []);
    op = [].concat(op || []);
    showType = showType || "simple";
    filterField = [].concat(filterField || []);
    filterValue = [].concat(filterValue || []);

    op.splice(0, 0, "");
    let removeId = 0;
    searchInput = searchInput.filter((v, k) => {
      if (v !== null && v !== undefined && v.trim() !== "") {
        return 1;
      } else {
        searchField.splice(k - removeId, 1);
        op.splice(k - removeId, 1);
        removeId++;
      }
      return "";
    });
    op.splice(0, 1);

    if (resourceType === "journal") {
      publicationType = "1";
    } else if (resourceType === "paper_journal") {
      publicationType = "3";
    } else if (resourceType === "ebook") {
      publicationType = "2";
    }

    let searchForm = {
      publicationType,
      pageNo,
      limit,
      searchField,
      searchInput: searchInput.map(
        Function.prototype.call,
        String.prototype.trim
      ),
      op,
      showType,
      filterField,
      filterValue,
      sort,
      order,
      subject,
      college,
      unit,
      resourceType,
      pageType,
      classSn,
      par,
      phonetic,
      strokes,
      language,
      alphabet,
      dbID,
      searchTarget,
      sc,
      domain,
      searchBlockType,
    };

    Object.keys(searchForm).map((key) => {
      if (
        searchForm[key] === null ||
        (typeof searchForm[key] === "string" && searchForm[key].trim() === "")
      ) {
        delete searchForm[key];
      }
      return "";
    });

    let defaultSearchBlockType = globalConfig["jumperrwd.resource.defaultSearchBlockType"] || "";
    if (defaultSearchBlockType === "") {
      defaultSearchBlockType = "resource";
    }

    let state = {
      searchForm: searchForm,
      auth: readerStore.auth,
      resourceType: resourceType,
      pageType: pageType,
      defaultSearchBlockType: defaultSearchBlockType,
    };

    return state;
  }

  @autobind
  resetPage() {
    let { search, location } = this.props;
    let params = { ...search };
    delete params["pageNo"];
    delete params["limit"];
    let path =
      Object.keys(params).length > 0
        ? [location.pathname, qs.stringify(params)].join("?")
        : location.pathname;
    navigate(path);
  }

  @autobind
  resourceListComp() {
    if (this.state.searchForm !== undefined) {
      switch (this.state.resourceType) {
        case "databases":
          return (
            <DBResourceListComp
              searchForm={this.state.searchForm}
              resourceType={this.state.resourceType}
              pageType={this.state.pageType}
              {...this.props}
            />
          );
        case "journal":
          return (
            <JournalResourceListComp
              searchForm={this.state.searchForm}
              resourceType={this.state.resourceType}
              pageType={this.state.pageType}
              {...this.props}
            />
          );
        case "paper_journal":
          return (
            <JournalResourceListComp
              searchForm={this.state.searchForm}
              resourceType={this.state.resourceType}
              pageType={this.state.pageType}
              {...this.props}
            />
          );
        case "ebook":
          return (
            <JournalResourceListComp
              searchForm={this.state.searchForm}
              resourceType={this.state.resourceType}
              pageType={this.state.pageType}
              {...this.props}
            />
          );
        default:
      }
    }
  }

  @autobind
  resourceListComp2() {
    if (this.state.searchForm !== undefined) {
      switch (this.state.resourceType) {
        case "databases":
          return (
            <DBResourceListComp2
              searchForm={this.state.searchForm}
              resourceType={this.state.resourceType}
              pageType={this.state.pageType}
              {...this.props}
            />
          );
        default:
      }
    }
  }

  render() {
    let { search, layoutStyleType } = this.props;
    let { defaultSearchBlockType } = this.state;
    let searchBlockType = search.searchBlockType || defaultSearchBlockType;
    return (
      <Layout {...this.props}>
        {layoutStyleType === "1" ? (
          <div className="main lp" id="center">
            <SearchBlock
              mode="resource"
              searchType={searchBlockType}
              resourceType={this.state.resourceType}
              searchForm={this.state.searchForm}
            />
            <ResourceListTab
              resourceType={this.state.resourceType}
              searchType={searchBlockType}
              searchForm={this.state.searchForm}
              {...this.props}
            />
            <section className="main_content erm">
              <div className="container">{this.resourceListComp()}</div>
            </section>
          </div>
        ) : layoutStyleType === "2" ? (
          <>
            <main className="main">
              <SearchBlock2
                mode="resource"
                searchType={searchBlockType}
                resourceType={this.state.resourceType}
                searchForm={this.state.searchForm}
              />
              {this.resourceListComp2()}
            </main>
          </>
        ) : (
          <></>
        )}
      </Layout>
    );
  }
}

export default ResourceList;
